export const locale = {
  lang: 'ar',
  data: {
    Enter_passport_number: "أدخل رقم جواز السفر",
    Enter_cr_number: "أدخل رقم السجل التجاري",        
    Enter_QID_number: "أدخل رقم الهوية القطرية",    
    "DUE": {
      "INSPECTION": "الفحص مستحق خلال {{value}}",
      "YEARS": "سنوات",
      "MONTHS": "أشهر",
      "DAYS": "أيام"
    },  
    "dashboard": {
      Appointment_on: 'تاريخ الموعد',
      Booking_Confirmed_for: 'حجز مؤكد لـ',
      Loading: 'يتم التحميل',
      "All_Vehicles": "جميع المركبات",
      "No_of_Vehicles": "عدد المركبات",
      "No_of_Tags": "عدد البطاقات",
      "Consumption_Daily": "الاستهلاك (يوميًا)",
      "Transation_Limit": "حد المعاملة",
      "Litres": "لترات",
      "Active": "نشط",
      "Deactive": "تعطيل الحساب",
      "Your_vehicle_Etag_is_deactive": "بطاقة مركبتك الإلكترونية غير نشطة.",
      "View_History": "عرض السجل",
      "Activate_Now": "تفعيل الآن",
      "View_all": "عرض الكل",
      "Add_New_Vehicle": "إضافة مركبة جديدة",

      
      ETag: "علامة إلكترونية",
      Beneficiary_Limit: "حد المستفيدين",
      Recent_Transactions: "المعاملات الأخيرة",
      Utilisation: "استخدام",
      Value_QAR: "القيمة (ريال قطري)",
      Edit_Limit: "تحرير الحد >",
      Modify: "تعديل",
      Assign_Limit: "وضع الحد >",
      Topup_Summary: "ملخص اشحن رصيدك",
      Assign_User_Limit: "تعيين حد المستخدم",
      Add_New: "أضف جديد",
      Appoinments: "المواعيد",
      Loyalty_points: "نقاط الولاء >",
      "Points_Redeemed": "النقاط المستبدلة",
      "Points_Earned": "النقاط المكتسبة",    
      "Order_ID": "رقم الطلب",
      "Activity_Type": "نوع النشاط",
      "Points_Change": "تغيير النقاط",
      "Activity_Date": "تاريخ النشاط",
      "Customer_Name": "اسم العميل",    
      In_Progress: "قيد العمل",
      Recept: "الوصفة",
      "statistics": "الإحصائيات",
      "topupAndUtilisation": "الشحن والاستخدام",
      "recentActivities": "الأنشطة الحديثة",
      "transactions": "المعاملات",
      "beneficiary": "المستفيد",
      "loyaltyPointsActivityLogs": "سجلات نشاط نقاط الولاء",
      "promoAndDiscounts": "العروض والخصومات"
    },  
    See_all: "عرض الجميع",
    "actions": "إجراءات",
    "profile_details": "تفاصيل الملف الشخصي",
    "first_name": "الاسم الأول",
    "last_name": "اسم العائلة",
    "email": "البريد الإلكتروني",
    "mobile": "رقم الهاتف",
    "qid": "رقم الهوية",
    "address": "العنوان",
    "dob": "تاريخ الميلاد",
    "gender": "الجنس",
    "wallet": "المحفظة",
    "current_balance": "الرصيد الحالي",
    "beneficiaries": "المستفيدين",  
    "dashboard_wallet": {
      Vehicles_List: "قائمة مركباتي",
      "Istamara_Expiry": "انتهاء الاستمارة في {{date}}",
      "Licence_plate": "رقم اللوحة",
      "Vehicle_Name": "اسم المركبة",
      "Time": "الوقت",
      "Date": "التاريخ",
      "Owner": "المالك",
      "Plate_type": "نوع اللوحة",
      "Category": "الفئة",  
      "Get_Direction": "احصل على الاتجاهات",
      "Download_Report": "تحميل التقرير",
      "Done": "تم",
      "Edit": "تعديل",
      "View_details": "عرض التفاصيل",
      "Service": "الخدمة",
      "Scheduled_Time": "الوقت المحدد",
      "Search_by_Plate_Number": "البحث برقم اللوحة",    
      "topUpSuccess": "تم شحن الرصيد بنجاح",
      "amount": "ريال قطري {{amount}}",
      "referenceId": "رقم المرجع: {{refId}}",
      "viewDetails": "عرض التفاصيل",
      "cardNumberLabel": "رقم البطاقة: {{card}}",
      "newBalance": "رصيدك الجديد هو",
      "balanceAmount": "{{balance}} ريال قطري",
      "savedSuccessfully": "تم الحفظ بنجاح",
      "paymentSummary": "ملخص الدفع",
      "paymentMethod": "طرق الدفع",
      "paymentMethodValue": "بطاقة ائتمان",
      "cardNumber": "رقم البطاقة",
      "cardNumberValue": "{{cardMasked}}",
      "serviceName": "اسم الخدمة",
      "serviceNameValue": "شحن رصيد",
      "location": "الموقع",
      "locationValue": "عبر الإنترنت",
      "downloadReceipt": "تحميل الإيصال"
    },  
    dashboardrevamp: {
      Get_the_offer: 'احصل على العرض',
      thisMonth: "هذا الشهر",
      service: "الخدمة",
      walletTransactions: "المحفظة والمعاملات",
      currentBalance: "الرصيد الحالي",
      transactions: "المعاملات",
      topup: "شحن",
      searchByServiceName: "البحث باسم الخدمة",
      name: "الاسم",
      invoice: "فاتورة",
      tracking: "تتبع",
      serviceName: "اسم الخدمة",
      dateTime: "التاريخ والوقت",
      status: "الحالة",
      amount: "المبلغ"  
    },
    "admin": {
      "Topup": "شحن",
      "LANGUAGE": "اللغة",
      "Dashboard": "لوحة التحكم",
      "My_Profile": "ملفي الشخصي",
      "My_Vehicle": "مركبتي",
      "Appointment_History": "سجل المواعيد",
      "Settings": "الإعدادات",
      "Notification": "الإشعارات",
      "Helps": "مساعدة",
      SMS_Messages: 'رسائل SMS',
      "my-profile": "ملفي الشخصي",
      "my-vehicles": "مركباتي",
      "appointment-history": "سجل المواعيد",
      "my-wallet": "محفظتي",
      "helps": "مساعدة"  
    },
    "popup": {
      Show_Receipt: "إظهار الايصال",
      Show_Payment_Receipt: 'إظهار إيصال الدفع',
      "Payment_Date": "تاريخ الدفع",
      "Licence_Plate": "رقم اللوحة",
      "Category": "الفئة",
      "VIN_Number": "رقم الهيكل",
      "SVC_Category": "فئة الخدمة",
      "Registered_on": "تاريخ التسجيل",
      "Download_Result": "تحميل النتيجة"
    },
    "inspection_new": {
      Success: "نجاح",
      Canceled: "إلغاء",
      Failed: "فشل",
      "change_booked_slot": "تغيير الموعد المحجوز",
      "proceed_with_payment": "المتابعة إلى الدفع",
      "vehicle_details": "تفاصيل المركبة",
      "vehicle_plate": "رقم اللوحة",
      "vehicle_name": "اسم المركبة",
      "vehicle_type": "نوع المركبة",
      "payment_summary": "ملخص الدفع",
      "payment_status": "حالة الدفع",
      "total": "الإجمالي"
    },  
    "inspection_details": {
      "inspection": "الفحص",
      "inspected_on": "تاريخ الفحص",
      "plate": "رقم اللوحة",
      "plate_type": "نوع اللوحة",
      "qid": "رقم الهوية",
      "technical_evaluation": "التقييم الفني",
      "chassis": "الشاسيه",
      "mileage": "المسافة المقطوعة",
      "inspection_validity": "تقرير الفحص صالح حتى:",
      "vehicle_inspection_report": "تقرير فحص المركبة",
      "passed": "اجتاز",
      "private": "خصوصي",
      "terms_and_conditions": "الشروط والأحكام",
      "terms_and_conditions_title": "الشروط والأحكام للفحوصات",
      "legal_requirements": "المتطلبات القانونية",
      "severity": "الخطورة",
      "minor": "طفيف",
      "major": "جسيم",
      "visual_faults": "عيوب بصرية / فنية",
      failed: "راسب"
    },  
    TIMES: {
      AM: 'ص',
      PM: 'م'
    },
    INSPECTION: {
      "Service_name": "اسم الخدمة",
      "Plate_Type": "نوع اللوحة",
      "Availability": "التوفر",
      "Check_your_availability_and_your_available_slots": "تحقق من مدى توفر الخدمة والمواعيد المتاحة لك",
      "Service_available_for_you": "الخدمات المتاحة لك",
      "Working_hours": "ساعات العمل",
      "Available_Slots": "المواعيد المتاحة",
      "Back": "رجوع",
      "Next": "التالي",
      "Search_Locations": "البحث عن المواقع",
      "Fully_Booked": "محجوز بالكامل",
      "Available": "متاح",
      "Selected": "محدد",
      "Disable": "غير متاح",
      "Vehicles_for_Inspection": "المركبة/المركبات للفحص",
      "Enable_Next_Due_Inspection": "تفعيل الفحص القادم المستحق",
      "Number_Plate": "رقم اللوحة",
      "Inspection_Paid": "تم دفع رسوم الفحص",
      "Book_Now": "احجز الآن",
      "Pay_Now": "ادفع الآن",
      "Remove_Vehicle": "إزالة المركبة",
      Remove_Vehicle_msg: "هل أنت متأكد أنك تريد إزالة المركبة؟",
      "View_last_inspection_report": "عرض تقرير الفحص الأخير",
      "Last_inspection": "آخر فحص",
      "Reg_Expiry": "انتهاء التسجيل",
      "Model": "الموديل",
      "Manufactor": "الشركة المصنعة",
      "Type": "النوع",
      "Booking_reference": "رقم الحجز",
      "Booking_Details": "تفاصيل الحجز",
      "Car_plate": "رقم لوحة المركبة",
      "Date_and_Time": "التاريخ والوقت",
      "Payment_Summary": "ملخص الدفع",
      "Payment_Status": "حالة الدفع",
      Booking_Slot: "وقت الحجز",
      "Total": "الإجمالي",
      "QAR": "ريال قطري",
      "Payment": "الدفع",
      "Select_any_payment_options_to_proceed_with_payment": "اختر أي وسيلة دفع للمتابعة",
      "Add_new_card": "أضف بطاقة جديدة",
      "Cancel": "إلغاء"
    },
    MAP: {
      ALL: 'الجميع',
      ALL_SERVICES: 'جميع الخدمات',      
    },
    GDPR: {
      GDPR_TITLE: 'نحن نقدر خصوصيتك',
      GDPR_SUBTITLE: "نستخدم ملفات تعريف الارتباط لتحسين تجربتك على موقعنا. لقبول جميع ملفات تعريف الارتباط، انقر على 'قبول الكل'. بدلاً من ذلك، يمكنك ضبط ملفات تعريف الارتباط المفضلة بالنقر على 'تفضيلات ملفات تعريف الارتباط'.",
      GDPR_LEARNMORE: 'اعرف المزيد',
      CUSTOMIZE: 'تفضيلات ملفات تعريف الارتباط',
      REJECT: 'رفض',
      ACCEPT: 'قبول'
    },
    HEADER: {
    },
    WIDGET: {
      CHAT_BOT: 'شات بوت',
      NOTIFICATIONS: 'إشعارات',
      SMS: 'رسائل SMS',
    },
    SHARED: {
      Mobile_number_must_start_with_974_or_00974: "يجب أن يبدأ رقم الموبايل بـ +974 أو 00974",
      GET_IN_TOUCH: "تواصل معنا",
      Have_a_question_or_Feedback: "هل لديك أي استفسارات أو ملاحظات؟",
      questions: "نحن هنا للإجابة على جميع استفساراتك وتقديم الدعم الذي تحتاجه. إذا كانت لديك اقتراحات أو أفكار جديدة، فنحن نرحب بها. لا تتردد في التواصل معنا، فنحن نتطلع إلى سماع رأيك وملاحظاتك! ",
      hear_them: "",
      READ_MORE: 'قراءة المزيد',
      SEARCH: 'بحث',
      DATE: 'تاريخ',
      NEW: 'جديد',
      Interested: "مهتم",
      All_Jobs: ' عرض جميع الوطائف',
      Feedback: 'رأيك',
      Locations: 'المواقع',
      Faq: "الأسئلة الشائعة",
      view_Faq: "عرض جميع الأسئلة",
      SUBMIT: "إرسال",
      CONTACT_US: 'تواصل معنا',
      SUBCRIBED_SUCCESSFULLY: 'تم الاشتراك بنجاح ',
      VIEW: "عرض",
      APPLY_ALL: 'تقديم الكل',
      FROM: 'من',
      TO: 'إلى',
      FILTER: 'تصفية',
      KEYWORD: 'الكلمة الرئيسية',
      HOME: 'الرئيسيه',
      LAST_UPDATE: 'تاريخ النشر',
      VIEW_ALL: 'عرض الجميع',
      CHOOSE_ONE: 'اختر واحدا',
      RELATION: 'القرابة',
      CHOOSE_Services: 'اختر الخدمات',
      VIEW_MORE: 'المزيد',
      LEARN_MORE: 'المزيد',
      ADDRESS: 'عنوان',
      PHONE: 'هاتف',
      FAX: 'فاكس',
      EMAIL: 'بريد إلكتروني',
      HOW_HELP: 'كيف يمكننا مساعدتك؟',
      WITH_GAS: 'مع غاز',
      Proceed: 'الشروع في دفع',
      LOAD: 'تحميل المزيد',
      LESS: 'عرض أقل',
      NO_DATA: 'ليس هنالك معلومات',
      VALID: 'صالح لغاية:',
      FAQ_CONTACT: 'الأسئلة الشائعة',
      FEEDBACKS: 'رأيك',
      HELP_YOU: 'نحن هنا لمساعدتك',
      OTHER_LOCATION: 'مواقع أخرى',
      PROCEED: 'متابعة',
      RELATED_IMAGES: 'صور ذات صلة',
      RELATED_VEDIOS: 'مفاطع ذات صلة',
      RELATED_FILES: 'ملفات ذات صلة',
      Inspection_FAQ: 'الأسئلة الشائعة حول الفحص',
    },
    HERO_HOME_PAGE_BOTTOM: {
      FUEL_PRICES: 'أسعار الوقود',
      Cash_Fuel_Prices: 'أسعار الوقود النقدية',      
      Everything_QJET_does_internally_or_externally: "كل ما تفعله QJET داخليًا أو خارجيًا",      
    },
    TENDER: {
      SUBSCRIBR_TO_ALERTS: 'اشترك لتلقي التنبيهات',
    },
    CURRENCIES: {
      QAR: 'ر.ق',
      QR: 'ريال قطري'
    },
    E_SERVICES_SECTION: {
      PRODUCT_SERVICES: 'منتجات وخدمات',
      TENDERS: "المناقصات",
      WHISTLE: 'كاشف الفساد',
      SERVICES: 'خدمات',
      ONLINE_INSPECTION_REPORT: 'تقرير التفتيش على الانترنت'
    },
    DASHBOARD: {
      Enter: "أدخل رقم",      
      "Add_Beneficiary": "إضافة مستفيد",
      "Select_a_Beneficiaries": "إضافة المستفيد",
      "back": "< رجوع",
      "First_Name": "الاسم الأول",
      "Last_Name": "اسم العائلة",
      "Email_short": "البريد الإلكتروني",
      "QID_Passport_Number": "رقم الهوية / رقم جواز السفر",
      "Enter_your_relative_type": "أدخل نوع القريب",
      "Enter_Wallet_Limit": "أدخل حد المحفظة",
      "Enter_your_first_name": "أدخل اسمك الأول",
      "Enter_your_last_name": "أدخل اسم عائلتك",
      "Enter_your_email": "أدخل بريدك الإلكتروني",
      "Enter_a_valid_ID": "أدخل رقم هوية صالح",
      "Enter_here": "أدخل هنا",
      "eg_QR_12000": "مثال: ١٢٠٠٠ ريال قطري",
      "Beneficiaries_added_successfully": "تمت إضافة المستفيدين بنجاح!",
      "New_Beneficiary_account_name_added_under_your_account_part1": "مستفيد جديد",
      "New_Beneficiary_account_name_added_under_your_account_part2": "تمت إضافته تحت حسابك",
      "Used": "المستخدم",
      "out_of": "من أصل",
      "Current_assigned_limit": "الحد الحالي المعين",
      "Limit_updated_successfully": "تم تحديث الحد بنجاح!",
      "Update_Limit": "تحديث الحد",
      "Instant": "فوري",
      "Set_limit_between_QR_200_to_QR_400": "قم بتعيين حد بين {{count1}} ريال قطري إلى {{count2}} ريال قطري",
      "Set_limit": "وضع الحد",
      "Assing_limit": "وضع الحد",
      Assing_limit2: "تعيين الحد",      
      "Daily": "يومي",
      "Weekly": "أسبوعي",
      "Monthly": "شهري",    
      Approval_pending: "الموافقة قيد الانتظار",
      The_added_beneficiary_approval_is_still_pending: "موافقة المستفيد المضاف لا تزال قيد الانتظار، يُرجى الانتظار",
      The_existing_beneficiaries_are_2_out_of_3: "عدد المستفيدين الحاليين: {{count1}} من أصل {{count2}}",
      You_can_add_other_beneficiary_later: "يمكنك إضافة مستفيد آخر لاحقًا",
      Beneficiary_account_removed: "تمت إزالة حساب المستفيد",
      Are_you_sure_you_want_to_deactivate_your_account_permanently: "هل أنت متأكد أنك تريد إلغاء تنشيط حسابك بشكل دائم؟",
      Are_you_sure_you_want_to_remove_this_beneficiary: "هل أنت متأكد أنك تريد إزالة هذا المستفيد؟",      
      Increase_for_additional_limit: "زيادة الحد الإضافي >",
      used_out_of: "مُستخدم من",
      Wallet_Limit: "حد المحفظة",
      Beneficiary_Account: "حساب مستفيد",
      Remove_Beneficiary: "إزالة المستفيد",
      Delete_Account: "حذف الحساب",
      HELP_YOU: 'نحن دائما هنا لمساعدتك',
      FIND: 'تجد هنا خيارات أخرى',
      TRANSACTIONS: 'المعاملات',
      TOPUP: 'إشحن',
      THIS_MOUNTH: 'هذا الشهر',
      SELECT_CAR: 'أختر مركبة',
      NEW_VEHICLE: 'إضافة مركبة جديدة',
      UPCOMING: 'القادمة',
      COMPLETED: 'مكتملة',
      CANCELLED: 'ألغيت',
      ADD_NEW_APPOINTMENT: 'إضافة موعد جديد',
      DASHBOARD: 'لوحة التحكم',
      PROFILE: 'الملف الشخصي',
      DEACTIVATE: 'تعطيل الحساب',
      Company_details: "تفاصيل الشركة",
      Beneficiaries: "المستفيدين",
      MY_PROFILE: 'ملفي',
      MY_VEHICLE: 'مركبتي',
      STEPS_APPOINTMENT: 'موعد الخطوات',
      APPOINTMENT_HISTORY: 'تاريخ التعيين',
      WALLET: 'المحفظة',
      Frequently: 'أسئلة مكررة',
      CHAT: 'الدردشة',
      CALL: 'مركز الاتصال (الدعم دون اتصال)',
      HELP: 'تحتاج مساعدة؟',
      WHATS_APP: 'واتساب',
      FACEBOOK: 'فيسبوك',
      INSTGRAM: 'انستغرام',
      SETTINGS: 'الأعدادات',
      HELP_ASIDE: 'للمساعدة',
      LANG: 'اللغة',
      ADMIN: 'مستخدم إداري',
      MODAL_SUB_TITLE: 'ستتم إزالة جميع التفاصيل المتعلقة بحسابك.',
      Email: 'الأيميل',
      PHONE: 'الهاتف',
      OTP_TITLE: 'احصل على كلمة مرور لمرة واحدة',
      OTP_DESC: 'سوف يرسل OTP رقم هاتفك المحمول المسجل',
      NUMBER: 'تكلفة العلامة + رسوم التثبيت',
      NUMBER_OF_TAG: 'عدد العلامات',
      TOTAL: 'السعر الكلي',
      BACK: 'خلف',
      SAVE_S: 'حفظ',
      SAVE: 'احفظ واستمر لاحقًا',
      NEXT: 'التالي',
      EDIT: 'تعديل',
      RECOMMENDED: 'الحجم الموصى به هو 256×256 بكسل، ويجب أن يكون بصيغة .jpg أو .png',
      ACCOUNT: 'نوع الحساب',
      AGREE: 'أنا أوافق على شروط وأحكام فاحص',
      BOOKING: 'إشعار تأكيد الحجز',
      BOOKING_NOTIFICATION: 'إشعار تغيير الحجز',
      ORDER: 'إشعار تسليم الطلب',
      EMAIL: 'إشعار البريد الإلكتروني',
      CURRENT: 'الرصيد الحالي',
      NOMINAL: 'أدخل المبلغ الاسمي كحد أدنى 100 ريال قطري',
      INSTANT: 'فوري',
      PAYMENT: 'الاستمرار في الدفع',
      VIEW_PROFILE: 'عرض الصفحة الشخصية',
      MY_WALLET: 'محفظتى',
      LOG_OUT: 'تسجيل خروج',
      EDIT_PROFILE: 'تعديل الملف الشخصي',
      Actions: 'أجراءات',
      Deactive: 'تعطيل الحساب',
      CANCEL: 'إلغاء',
      SAVE_CHANGES: 'حفظ التغييرات',
      RESONE_FOR_DEACTIVATE: 'تعطيل الحساب',
      RESONE_FOR_DELETE: 'سبب الحذف',
      FAILED: 'فشل',
      NA: 'غير متوفر',
      SUCCESS: 'فعال',
    },
    PROMOTIONS: {
      PROMOTIONS: 'العروض',
      VIEW_ALL_PROMOTIONS: 'عرض كل العروض',
      VIEW_ALL: 'عرض الكل',
      RELATED_PROMOTIONS: 'العروض ذات الصلة',
      OFFERS_AND_PROMOTIONS: "العروض والعروض الترويجية",
      PROMOTIONS_EXPIRED_ON: "ينتهي العرض في",
      LATEST_PEOMOTIONS: 'أحدث العروض الترويجية',
    },
    NEWS: {
      VIEW_ALL_NEWS: 'عرض كل الأخبار',
      PRESS_RELEASE_NEWS: 'الصحافة والأخبار'
    },
    SOCIAL_WIDGET: {
      CHECK_ALL: 'تحقق من الكل',
      SOCIAL_ACCOUNTS: 'حسابات التواصل الاجتماعي'
    },
    WALLET: {
      Fuel_Transactions: "معاملات الوقود",
      Payouts: "المدفوعات",
      Topup_History: "سجل الشحن",
      Other_Services: "خدمات أخرى",
      "Date": "التاريخ",
      "Amount": "المبلغ",
      "Address": "العنوان",
      "Plate_number": "رقم اللوحة",
      "Time": "الوقت",
      "Payment_Type": "نوع الدفع",
      "Service_Type": "نوع الخدمة"
    },
    FEEDBACK: {
      Vehicles: "مركبات",
      FEILD_CANT: "لا يمكن أن يكون الحقل فارغًا",
      FULL_NAME: 'الاسم الكامل',
      COMPANY: 'شركة',
      TITLE: 'عنوان',
      EMAIL: 'عنوان البريد الإلكتروني',
      COMMENT: 'تعليق',
      MOBILE_NUMBER: 'رقم الهاتف المحمول',
      PLATE_NUMBER: 'رقم اللوحة',
      CATEGORY: 'الفئة',
      SOURCE: 'المصدر',
      SECTOR: 'القطاع',
      SELECT_SECTOR: 'حدد القطاع',
      SELECT_CATEGORY: 'اختر فئة',
      SELECT_SOURCE: 'اختر المصدر',
      SELECT_DEPATMENT: 'اختر القسم',
      SELECT_TYPE: 'حدد نوع التعليق',
      SELECT_PLATE_TYPE: 'نوع اللوحة',
      DEPARTMENT: 'حدد القسم',
      type: '  حدد نوع الملاحظة',
      ATTACHMENT: 'المرفقات',
      SERVIECS: 'خدمات ',
      NAME: 'الاسم',
      DESCRIPTION: 'الوصف',
      FORM_TITLE: 'نموذج الملاحظات',
      CONNECT: 'تواصل معنا للحصول على فرص عمل جديدة وتعاون',
      CONTACT_US: 'اتصل بنا',
      CONTACT_SELECT: 'حدد أيًا من الخيارات أدناه للمتابعة',
      ATTACHMENT_UPLOAD: 'قم بتحميل ملفك',
      HINT: 'قم بتحميل الملفات ذات الامتدادات xls، xlsx، doc، docx، PDF، JPEG، PNG، وJIF. الحد الأقصى لحجم الملف المسموح به هو 5 ميجا بايت، ويمكن للمستخدم إضافة ما يصل إلى 5 مرفقات.',
      WRITE_HERE: 'اكتب هنا…'
    },
    PETROL_STATION: {
      CNG: "الغاز الطبيعي المضغوط",
      All_Stations: "جميع المحطات",
      ALL: "الكل",
      sidra_stand_alone: "محطة وقود سيدرا المستقلة",
      sidra_petrol_station: "محطة وقود سيدرا",

      PETROL_STATION: 'محطة وقود',
      FIND_THE_NEAREST_PETROL_STATION_AND_KNOW_THE_SERVICES_IT_OFFERS: 'ابحث عن أقرب محطة وقود واعرف الخدمات التي تقدمها',
      SELECT_YOUR_PETROL_STATION_TYPE: 'اختر نوع محطة الوقود الخاصة بك',
      SELECT_YOUR_PETROL_STATION_STATUS: 'اختر حالة محطة الوقود الخاصة بك',
      SELECT_FROM_LIST_OF_THE_SERVICES: 'اختر من قائمة الخدمات',
      FIND_YOUR_PETROL_STATION: 'ابحث عن محطة الوقود',
      FIND_YOUR_STATION: 'ابحث عن المحطة الخاصة بك',
      FIND_YOUR_SIDRA_STATION: 'ابحث عن محطة سيدرا الخاصة بك',
      FIND_YOUR_CNG_STATION: "ابحث عن محطة الغاز الطبيعي المضغوط الخاصة بك",
      CLEAR_SELECTED_FILTERS: 'مسح الفلاتر المحددة',
      EXPLORE_MORE_SERVICES: 'اكتشف المزيد من الخدمات',
      CLEAR_FILTERS: 'مسح الفلاتر',
      RESET_ALL: 'إعادة تعيين الكل',
      MARINE_STATION: 'المحطة البحرية',
      MOBILE_STATION: 'محطة متنقلة',
      ACTIVE: 'نشيط',
      NEAR: 'محطة بنزين بالقرب مني',
      UPCOMING: 'القادمة',
      SEND: 'يرسل',
      FUEL: 'وقود',
      SIDRA: 'سدرة',
      ALL_TYPES: 'جميع الأنواع',
      STAND_ALONE: 'قائمة بذاتها'
    },
    FOOTER: {
      COPY_RIGHT_WITHOUT_YEAR: 'جميع الحقوق محفوظة © {{pageType}}',
      COPY_RIGHT_WITH_YEAR: 'جميع الحقوق محفوظة © {{cYear}}, {{pageType}}'
    },
    SHARE_BREADCRUMB: {
      SHARE_THIS: 'شارك هذا',
      SHARE: 'شارك :',
    },
    PROMOTION_FILTER: {
      FILTER_PROMOTIONS: 'تصفية العروض',
      LOCATION: 'الموقع',
      DATE_RANGE: ' التاريخ',
      PROMOTION_CATEGORY: 'فئة العرض',
      PROMOTION_STATUS: 'حالة العرض',
      APPLY_FILTER: 'انقر هنا'
    },
    ABOUT_US: {
      OUR_MISSION: 'مهمتنا',
      OUR_STORY: "قصتنا",
      READ_FULL_STORY: "اقرأ القصة الكاملة",
      OUR_LEADERSHIP: "قيادتنا",
      OUR_HERITAGE: "تراثنا",
      OUR_VISION: "رؤيتنا",
      OUR_VALUES: "قيمنا",
      PROFESSIONAL: "محترف",
      RLEATED: 'الصفحات المتعلقة بالمحتوى',
      RLEATED_CONTENT: 'المحتوى ذو الصلة',
    },
    QJET_MEDIA_CENTER: {
      NEWS: 'الأخبار والإعلانات',
      MULTIMEDIA: 'الوسائط المتعددة',
      EVENTS: 'الأحداث',
      VIEW: 'رؤية الجميع',
      OUR_LASTEST_NEWS: 'آخر الأخبار والإعلانات لدينا',
      OUR_LASTEST_MULTIMEDIA: 'أحدث الوسائط المتعددة لدينا',
      OUR_LASTEST_EVENTS: 'أحدث الأحداث لدينا',
      READ_MORE: 'المزيد',
      READ_LESS: 'عرض أقل',
      SEARCH: 'البحث من هنا',
      FILTER: 'فلترة',
      LOAD_MORE: 'تحميل المزيد',
      MILESTONES: 'معالم',
      OF: 'من',
    },
    PERIOD: {
      PM: 'مساءاً',
      AM: 'صباحاً',
    },
    MONTHS: {
      JAN: 'يناير',
      FEB: 'فبراير',
      MAR: 'مارس',
      APR: 'أبريل',
      MAY: 'مايو',
      JUN: 'يونيو',
      JUL: 'يوليو',
      AUG: 'أغسطس',
      SEP: 'سبتمبر',
      OCT: 'أكتوبر',
      NOV: 'نوفمبر',
      DEC: 'ديسمبر',

      JANUARY: "يناير",
      FEBRUARY: "فبراير",
      MARCH: "مارس",
      APRIL: "أبريل",
      JUNE: "يونيو",
      JULY: "يوليو",
      AUGUST: "أغسطس",
      SEPTEMBER: "سبتمبر",
      OCTOBER: "أكتوبر",
      NOVEMBER: "نوفمبر",
      DECEMBER: "ديسمبر"
    },
    TRAFFIC_SERVISE: {
      TITLE_STORY: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
      BUTTON_STORY: 'MOI',
      STATION: 'خريطة المحطة',
      INSURANCE: 'تأمين',
      LOCATION: 'موقع',
      STATUS: 'حالة المحطة',
      STATION_CONTACT: 'تفاصيل جهات اتصال المحطة',
      TYPE: 'نوع المحطة',
      AVAILABLE: 'الخدمات المتاحة',
    },
    SERVICE_INSPESTION: {
      Congratulations_Your_booking_has_been_reserved_for_the: "تهانينا! تم حجزك لـ {{serviceName}}",      
      Back_to_Vehicle_Listing: "العودة إلى قائمة المركبات",
      Initiate_Booking: "بدء الحجز",
      Congratulations_Your_payment_has_been_successfully_made: "مبروك! تم الدفع بنجاح.",
      Payment_DateTime: "وقت وتاريخ الدفع",
      View_Booking_Details: "عرض تفاصيل الحجز",
      Pending: "مُعلّق",
      Paid: "مدفوع",
      Payment_Status: "حالة الدفع",
      Booking_Slot: "فترة الحجز",
      "Booking_confirm_for": "حجز مؤكد لـ",
      Already_Booked: "محجوز مسبقا",
      Cancel_Booking: "إلغاء الحجز",
      Back_To_Home: "العودة إلى الصفحة الرئيسية",
      Modify_Booking: "تعديل الحجز",
      Inspections: "عمليات التفتيش",
      "Select_any_payment_options_to_proceed_with_payment": "اختر أي وسيلة دفع للمتابعة مع الدفع",
      "Wallet_Payment": "دفع عبر المحفظة",
      "Select_a_wallet_to_complete_your_payment_securely": "اختر محفظة لإتمام الدفع بأمان.",
      "Available_Balance": "الرصيد المتاح",
      "Payment_reference": "مرجع الدفع",
      Payment_Confirmed_for_a_vehicle_plate_number: "تم تأكيد الدفع لرقم لوحة المركبة",
      Booking_Confirmed_for_a_vehicle_plate_number: "تم تأكيد الحجز لرقم لوحة المركبة",            
      Payment_Confirmed_for_a_vehicle_plate_number_withstatus: "تم {{status}} الدفع لرقم لوحة المركبة",
      Congratulations_Your_slot_has_been_reserved_for_the_inspection: "تهانينا! تم حجز موعدك للفحص.",
      Vehicle_category: "فئة المركبة",
      Disclaimer_part1: "**تنويه: يُرجى الحضور إلى المحطة",
      Disclaimer_part2: "قبل 15 دقيقة",
      Disclaimer_part3: "من وقت الحجز المحدد.",      
      Confirm_Pay_Later: "تأكيد و الدفع لاحقًا",
      Confirm_And_Proceed_To_Pay: "تأكيد والمتابعة إلى الدفع",
      I_agree: "أوافق",
      Terms_Conditions: "الشروط والأحكام",
      Terms_and_conditions_for_Inspections: "الشروط والأحكام الخاصة بالفحوصات",
      Open_24_hours: "مفتوح 24 ساعة",
      Station_Details: "تفاصيل المحطة",
      Vehicle_Name: "اسم المركبة",
      Plate_Type: "نوع اللوحة",
      Disclaimer_Review_and_confirm_booking_before_time_runs_out: "**تنويه: يرجى مراجعة وتأكيد الحجز قبل انتهاء الوقت.",
      Total: "الإجمالي",
      QAR: "ريال قطري",
      Appointment: "الموعد",
      Date: "التاريخ",
      Time_Slot: "الفترة الزمنية",
      Open: "مفتوح من",
      Summary_of_your_booking_for_a_vehicle_plate_number: "ملخص حجزك لرقم لوحة المركبة",
      Please_review_the_below_details_and_confirm_your_slot_for_the_reservation: "يرجى مراجعة التفاصيل أدناه وتأكيد الفترة الزمنية لحجز",
      Please_review_the_below_details_and_confirm_your_slot_for_the_reservation_dynamic: "يرجى مراجعة التفاصيل أدناه وتأكيد الفترة الزمنية لحجز {{serviceName}}",      
      "Useful_Tips": "نصائح مفيدة",
      "You_dont_have_any_vehicles_registered_on_your_account": "ليس لديك أي مركبات مسجلة في حسابك. يُرجى إضافة مركبة لإكمال حجز الفحص.",
      "aVehicleType": "نوع المركبة",
      "ownerQId": "الرقم الشخصي للمالك",
      "dateFirstRegistered": "تاريخ التسجيل الأول",
      "vehicleWeight": "وزن المركبة (كجم)",
      "vehicleWeightwithLoad": "وزن المركبة مع الحمولة (كجم)",
      "inspectionType": "نوع الفحص",
      "expiresOn": "تاريخ الانتهاء",  
      Shape_of_Vehicle: "شكل المركبة",
      Beneficiary: "المستفيد",
      Registration_Type: "نوع التسجيل",
      YOUR_BOOKING: 'تم تأكيد حجزك بنجاح',
      CONGRATS: 'تهانينا، لقد تم حجز التذاكر الخاصة بك بنجاح',
      ID: 'معرف تأكيد الحجز:',
      VIEW_SUMMARY: 'ملخص رأي',
      BOOKING_SUMMARY: 'ملخص الحجز',
      ASSIGN: 'تعيين وظيفة',
      FEE: 'ضريبة تفتيش',
      APPOINTMENT: 'الرقم المرجعي للموعد ',
      NAME: 'الاسم المخصص',
      REMOVE: 'إزالة المركبة',
      SELECT: 'اختار',
      CANCEL: 'الغاء',
      CONFIRM: 'يتأكد',
      NO_OF: 'رقم المركبة:',
      APPLY: 'تنطبق على الجميع',
      BACK: 'العودة إلى التفتيش',
      DUE: 'التفتيش الواجب',
      CLEAR: 'امسح الكل',
      SORT: 'ترتيب حسب:',
      ONLY: 'إعادة الفحص مرة واحدة فقط مجانية',
      APPROX: 'السعر الإجمالي تقريبًا',
      LIST: 'التالي قائمة مركبات الفحص الواجب',
      DESCRIPTION: 'المركبات الفردية التي يقل عمرها عن 3 سنوات، لا تحتاج إلى فحص',
      BOOKING_CONFIREMD: 'تاكيد الحجز',
      REFERENCE: 'معلومات الحجز',
      VEHICLE_NAME: 'اسم المركبة',
      PLATE: 'طبق',
      AMOUNT: 'كمية',
      DATE: 'تاريخ ووقت الموعد',
      CHOOSE: 'اختر مركبتك',
      DATE_TIME: 'حدد التاريخ والوقت',
      INSPECTED_DATE: 'تاريخ التفتيش',
      INSPECTED_STATUS: 'حالة التفتيش',
      DATE_AND_TIME: 'التاريخ والوقت',
      PAYMENT: 'ملخص الدفع',
      NO_OF_CAR: 'عدد المركبات',
      PRICE_SELECTED: 'سعر المركبة المختارة',
      SUB_TOTAL: 'المجموع الفرعي',
      CANCEL_BOOKING: 'هل أنت متأكد من رغبتك في الإلغاء؟',
      remove_CARD: 'إزالة بطاقة',
      CANCEL_CARD: 'هل أنت متأكد أنك تريد إزالة البطاقة؟',
      YES: 'نعم',
      NO: 'لا',
      ISTEMARA_MESSAGE: 'لا تزال استمارة (تسجيل المركبة) هذه المركبة صالحة لأكثر من 100 يوم! هل ما زلت ترغب في متابعة حجز الفحص؟',
      New_Vechile: 'أضف مركبة جديدة',
      SAVE_PROCEED: 'احفظ وتابع الحجز',
      PLATE_DETAILS: 'تفاصيل لوحة المركبة',
      VEHICLE_INFORMATION: 'معلومات المركبة',
      OWNER_NAME: 'اسم المالك',
      OWNER_ID: 'رقم هوية المالك',
      OTHER_COLOR: 'وصف اللون الآخر',
      OWNER_NATIONALTIY: 'جنسية المالك',
      COUNTRY: 'الدولة',
      CHASIS: 'رقم الهيكل',
      CONTACT_TRAFFIC: 'الاتصال بالمرور',
      ENGINE_NUMBER: 'رقم المحرك',
      FIRST_REGISTRATION: 'تاريخ التسجيل الأول',
      LOAD_WEIGHT: 'وزن الحمولة',
      MAIN_COLOR_DESC: 'وصف اللون الرئيسي',
      MAIN_SHADE_DESC: 'وصف الظل الرئيسي',
      MANUFACTURE_DESCRIPTION: 'وصف الشركة المصنعة',
      MODEL_DESCRIPTION: 'وصف الطراز',
      MODEL_YEAR: 'سنة الصنع',
      NUMBER_OF_CYLINDERS: 'عدد الأسطوانات',
      NUMBER_OF_SEATS: 'عدد المقاعد',
      PLATE_NUMBER: 'رقم اللوحة',
      PLATE_TYPE: 'نوع اللوحة',
      PLATE_TYPE_DESCRIPTION: 'وصف نوع اللوحة',
      REGISTRATION_END_DATE: 'تاريخ انتهاء التسجيل',
      REGISTRATION_REN_DATE: 'تاريخ تجديد التسجيل',
      TEST_REQUIRED: 'الفحص مطلوب',
      VIHICLE_STYLE_DESCRIPTION: 'وصف نمط المركبة',
      A_VEHICLE_TYPE: 'نوع المركبة',
      VIHICLHE_WEIGHT: 'وزن المركبة',
      VIHCHLE_WEIGHT_WITH_LOAD: 'وزن المركبة مع الحمولة'

    },
    MEDIA_TYPES: {
      ALL: 'الكل',
      VIDEOS: 'مقاطع الفيديو',
      GALLERIES: 'معارض الصور',
      IMAGES: 'الصور',
      INFOGRAPHICS: 'إنفوجرافيك'
    },
    MEDIA_CENTER: {
      NEWS_AND_ANNOUNCMENTS: 'أخبار وإعلانات',
      MULTIMEDIA: 'وسائط متعددة',
      EVENTS: 'فعاليات',
      PUBLISHED: 'تم النشر:',
      START_DATE: 'تاريخ البدء:',
      END_DATE: 'تاريخ الانتهاء:',
      RELATED_NEWS: 'أخبار ذات صلة',
      RELATED_EVENTS: 'فعاليات ذات الصلة',
    },
    EVENT: {
      EVENT_CATEGORY: 'جميع الفئات',
      FILTER_THE_EVENT_BY: 'تصفية الأحداث حسب',
      EVENT_INFORMATION: 'معلومات الفعالية ',
    },
    MULTIMEDIA: {
      SEARCH_BY_NAME_DESCRIPTION: 'البحث بالاسم / الوصف',
      SEARCH_BY_NAME: 'البحث بالاسم'
    },
    BREADCRUMB: {
      CORPORATE_SOCIAL_RESPONSIBILITY: 'المسؤولية الاجتماعية للشركات',
      BECOME_A_SUPPLIER: 'كن موردًا',
      TENDER_REQUEST: 'طلب عطاء',
      TENDER_ALERT: 'تنبيه العطاء',
      TENDERS_AND_SUPPLIER: 'المناقصون والموردون',
      PAGES: 'الصفحات',
      SUCCESS: 'نجاح',
      MEDIA_CENTER: 'المركز الإعلامي',
      NEWS_AND_ANNOUNCEMENTS: 'الأخبار والإعلانات',
      NEWS: 'الأخبار',
      EVENTS: 'الفعاليات',
      MULTIMEDIA: 'وسائط متعددة',
      VIDEOS: 'فيديوهات',
      GALLERIES: 'معارض الصور',
      IMAGES: 'صور',
      ENVIRONMENTAL_MANAGEMENT: 'الإدارة البيئية',
      PETROL_STATION_SAFETY_INSTRUCTIONS: 'تعليمات السلامة في محطات الوقود',
      INTEGRATED_MANAGEMENT_SYSTEM: 'نظام إدارة متكامل',
      AWARENESS_CAMPAIGN: 'حملة توعية',
      BRAND_GUIDELINES: 'إرشادات العلامة التجارية',
      COMPANY_PROFILE: 'ملف الشركة',
      HEALTH_AND_SAFETY: 'الصحة و السلامة',
      PROMOTIONS: 'العروض',
      QJET: 'QJET',
      CODE_OF_ETHICS: 'مدونة قواعد الأخلاق والسلوك',
      CAREERS: 'وظائف',
      WHAT_WE_DO: 'الذي نفعله',
      EQUALITY_DIVERSITY_INCLUSION: 'المساواة والتنوع والشمول',
      WHAT_WE_LOOK_FOR: 'ما نبحث عنه',
      INTERVIEW_TIPS: 'نصائح حول المقابلة',
      GET_NOTICED: 'جذب الانتباه',
      TALENT_DEVELOPMENT_STRATEGY: 'إستراتيجية تطوير المواهب',
      QATARAIZATION: 'التقطير',
      BENEFITS: 'الفوائد',
      MEET_OUR_TEAM: 'قابل فريقنا',
      FIVE_WAYS_TO_HELP_YOU_FIND_THE_RIGHT_CAREER_PATH: 'خمس طرق لمساعدتك في العثور على المسار الوظيفي الصحيح',
      SEARCH_RESULT: 'نتائج البحث',
      SYSTEMS_AND_REGULATION: 'الأنظمة واللوائح',
      RETAIL: 'بيع بالتجزئة',
      AUTO_CARE_SERVICE: 'خدمة العناية بالمركبات',
      FAQ: 'الأسئلة الشائعة',
      SUSTAINABILITY: 'الاستدامة',
      VISION_MISSION_VALUES: 'الرؤية الرسالة القيم',
      ABOUT_US: 'عن الشركة',
      KENAR_SHOP: 'متجر كنار',
      SIDRA: 'سدرة',
      TENDER_DETAILS: 'تفاصيل المناقصة',
      TENDER_AND_SUPPLIER: 'المشتريات والعقود',
      SHAFAF: 'شفاف',
      SERVICES: 'الخدمات',
      ERM: 'ERM',
      LUBRICANTS: 'Lubricants',
      CAREER_JOBS: 'التقدم للوظائف',
      LEADERSHIP: 'قيادتنا',
      BUSINESS_CONTINUITY_MANAGEMENT: 'إدارة استمرارية الأعمال',
      ENTERPRISE_RISK_MANAGEMENT: 'إدارة مخاطر المؤسسة',
      Document: 'الوثائق',
      REQUEST_E_TAG: 'طلب العلامة الإلكترونية',
      TENDER: 'المناقصة'
    },
    CAREER_FILTER: {
      KEYWORD_SEARCH: 'بحث بالكلمات الدلالية',
      SELECT_LOCATION: 'اختر الموقع',
      SELECT_DEPARTMENTS: 'اختر الأقسام',
      FILTER_BY_TAGS: 'تصفية حسب العلامات',
      MORE_TAGS: 'علامات أكثر',
      FILTER_BY_SALARY_RANGE: 'تصفية حسب نطاق الراتب',
      FULL_TIME_ONLY: 'دوام كامل فقط',
      INSIDE_DOHA_QATAR: 'داخل الدوحة قطر',
      FILTER: 'منقي',
      SUBSIDIARY: 'شركة فرعية',
    },
    RANGE: {
      MIN_SALARY: 'الحد الأدنى للراتب',
      MAX_SALARY: 'الحد الأقصى للراتب'
    },
    CAREER_LISTING: {
      current_location: "الموقع الحالي",
      Job_Details: "تفاصيل الوظيفة",
      Apply: "التقدم للوظيفة",
      JOB_ID: 'معرف الوظيفة',
      INDUSTRY: 'الصناعة',
      JOB_INFORMATION: 'معلومات مهمة',
      JOB_TIME: 'وقت العمل',
      JOB_LOCATION: 'الموقع الحالي',
      CITY: 'مدينة',
      STATE: 'الولاية/المقاطعة',
      COUNTRY: 'دولة',
      SALARY: 'مرتب',
      ZIP: 'الرمز البريدي / الرمز البريدي',
      REQUIREMENTS: 'متطلبات',
      JOB_REQUIREMENTS: 'متطلبات الوظيفة',
      COMPANY: 'الشركة',
      DETAILS: 'تفاصيل',
      INTERSTED: 'انا مهتم',
      REQUEST: 'طلب وثيقة',
      CAREER_JOB: 'مسمى وظيفي',
      SECOND_NAME: 'الاسم الثاني',
      NATIONALITY: 'الجنسية',
      CV_FILE: 'ملف السيرة الذاتية',
      EDUCATION_DEGREE: 'المؤهل العلمي',
      FIELD: 'مجال الدراسة',
      CURRENT: 'حالة التوظيف الحالية',
      YEARS: 'سنوات الخبرة',
      WORK: 'مجال العمل الحالي/السابق',
      EMPLOYER: 'صاحب العمل الحالي/السابق',
      UNVIERSITY: 'الشهادة التعليمية',
      DESC: 'الوصف',
      JOB_CODE: 'رمز الوظيفة',
      APPLYING: 'أنت تتقدم بطلب للحصول على',
      DESCRIPTION: 'الوصف',
      DATE_APP: 'الموعد النهائي لتقديم طلبات التوظيف',
    },
    TENDER_DETAILS: {
      Transation_date: 'تاريخ الحركه',
      TENDER_INFORMATION: 'معلومات العطاء',
      S_NUMBER: 'الرقم التسلسلي للعطاء',
      TENDER_NUMBER: 'رقم المناقصة',
      TEBDER_CATEGORY: 'فئة المناقصة',
      FEE: 'مصاريف',
      SCOPE: 'مجال العمل',
      INFO: 'معلومات العطاء',
      PAYMENT: 'قسط',
      OPTIONS_PAYMENY: 'حدد أي من خيارات الدفع للمتابعة في الدفع',
      REQUEST: 'تم تأكيد الدفع لطلب العطاء رقم 123456',
      CONGRATS: 'مبروك، مستندك جاهز للتحميل من الرابط التالي',
      DOWNLOAD: 'تنزيل الإيصال',
      INVOICE: 'تاريخ الفاتورة',
      DATE: 'تاريخ',
      TIME: 'وقت',
      DOWNLOAD_TENDER: 'تنزيل وثيقة العطاء',
      RECIPE_SUMMARY: 'ملخص الوصفة',
      CUSTOMER: 'اسم الزبون',
      MOBILE: 'رقم الهاتف المحمول',
      PAYMENY_DATE: 'تاريخ الدفع',
      RECIPE_NO: 'الوصفة رقم',
      RECIPT_NO: 'عدد إيصال',
      TRANSACTION: 'رقم المعاملة',
      TOTAL: 'إجمالي المبلغ المدفوع'
    },
    PLURAL: {
      JOB: {
        ZERO: '0 وظائف',
        SINGULAR: 'وظيفة واحده',
        DUAL: 'وظيفتان',
        BETWEEN_THREE_NINE: '{{count}} وظائف',
        TEN: '{{count}} وظائف',
        MORE_THAN_TEN: '{{count}} وظيفة',
      },
      DAYS_LEFT: {
        ZERO: '{{count}} Days Left',
        SINGULAR: '{{count}} Day Left',
        DUAL: '{{count}} Days Left',
        BETWEEN_THREE_NINE: '{{count}} Days Left',
        TEN: '{{count}} Days Left',
        MORE_THAN_TEN: '{{count}} Days Left'
      }
    },
    ERRORS: {
      set_limit_between_QR_val1_to_QR_val2: 'ضع الحد بين {{val1}} ريال قطري و {{val2}} ريال قطري',
      something_went_wrong: "لقد حدث خطأ ما",
      at_least_3_characters_are_required: "يجب أن يكون هناك 20 من أحرف على الأقل",
      at_least_33_characters_are_required: "يجب أن يكون هناك 3 من أحرف على الأقل",
      at_least_11_characters_are_required: "يجب أن يكون هناك 11 حرف على الأقل",
      THIS_FIELD_IS_REQUIRED: 'هذه الخانة مطلوبة',
      YOUR_BROWSER_DOES_NOT_SUPPORT_HTML5_VIDEO: 'متصفحك لا يدعم فيديو HTML5.',
      Email: 'عنوان البريد الإلكتروني الذي أدخلته غير صالح',
      CR: 'رقم جواز السفر الذي أدخلته غير صالح',
      VALUE_TOO_LOW: 'القيمة منخفضة للغاية',
      VALUE_EXCEEDS_LIMIT: 'القيمة تتجاوز الحد',
      EMAILS_DO_NOT_MATCH: 'البريد الإلكتروني غير مطابق',
      PATTERN: 'يجب أن يكون رقم جواز السفر بالتنسيق التالي: xx-xxxx-xx.',
      DATE: ' يرجى التأكد من تعبئة "من تاريخ" و "إلى تاريخ" لتتمكن من التصفية بشكل صحيح.',
      ERROR: 'خطأ',
      PAGE_NOT_FOUND: 'الصفحة غير موجودة',
      CANT_FIND: 'عذراً، لم نتمكن من العثور على الصفحة التي تبحث عنها.',
      UNPUBLIESD:'الصفحة التي تبحث عنها لا يمكن الوصول إليها في الوقت الحالي.',
      GO_HOME: 'العودة إلى الصفحة الرئيسية',
      LOGIN_MOBILE_NUMBER:'الرجاء إدخال رقم موبايل صحيح',
    },
    SIGN_IN: {
      Please_enter_OTP: 'يرجى إدخال OTP',
      We_have_sent_verification_code_to_your_Email: 'لقد أرسلنا رمز التحقق إلى بريدك الإلكتروني، يرجى التحقق من بريدك الإلكتروني',
      We_have_sent_verification_code_to_your_mobile_number: 'لقد أرسلنا رمز التحقق إلى رقم هاتفك المحمول',
      Verification_Code_sent_to: 'تم إرسال رمز التحقق إلى',
      Enter_the_Code: 'أدخل الرمز',
      Resend_PIN: 'إعادة إرسال رمز PIN',
      sec: 'ثانيه',
      Verify_Code: 'رمز التحقق',
      Confirm: 'تأكيد',
      LOG_IN: 'تسجيل دخول',
      Login_by_mobile_number: "تسجيل الدخول برقم الهاتف المحمول",
      Email_Address: "عنوان البريد الإلكتروني",
      Enter_Email_Address: "أدخل عنوان البريد الإلكتروني",
      Enter_Verification_Code: "أدخل رمز التحقق",
      Verification_Code: '929396',
      Send_OTP: 'إرسال OTP',
      or: 'أو',
      Login_by_Email: 'تسجيل الدخول عبر البريد الإلكتروني',
      Protected_by_reCAPTCHA_and_subject_to_the: 'محمي بواسطة reCAPTCHA وخاضع لـ',
      Qjet_Privacy_Policy: 'سياسة خصوصية وقود',
      and: 'و',
      Terms_of_Service: 'شروط الخدمة',
      FULL_ADDRESS: 'العنوان الكامل',
      SIGN_IN_QJET: 'تسجيل الدخول إلى وقود',
      ENTER_MOBILE_NUMBER: 'أدخل رقم الهاتف',
      RESEND_IN: 'إعادة الإرسال في',
      RESEND: 'إعادة الإرسال',
      ENTER_VERIFICATION_CODE: 'أدخل رمز التحقق',
      LOGIN: 'تسجيل الدخول',
      OR: 'أو',
      CONTINUE_AS_A_GUEST: 'المتابعة كضيف',
      ENTER_YOUR_PROFILE_DETAILS: 'أدخل تفاصيل ملفك الشخصي',
      FULL_NAME: 'الاسم الكامل',
      EMAIL: 'البريد الإلكتروني',
      ADDRESS: 'العنوان',
      DATE_OF_BIRTH: 'تاريخ الميلاد',
      IAM_MAN: 'أنا رجل',
      IAM_WOMAN: 'أنا امرأة',
      CONTINUE: 'متابعة',
      PROTECTED_BY_RECAPTCHA_AND_SUBJECT_TO_BE: 'محمي بواسطة reCAPTCHA وخاضع لـ',
      AND: 'و',
      TERMS_OF_SERVICE: 'شروط الخدمة',
      FIRST_NAME: 'الاسم الأول',
      LAST_NAME: 'اسم العائلة',
      VERIFY: 'التحقق',
      QID: 'رقم الهوية',
      QID_PASSPORT: 'رقم الهوية/جواز السفر',
      POBOX: 'صندوق البريد',
      COUNTRY: 'البلد',
      CITY: 'مدينة',
      STREET: 'عنوان الشارع',
      GENDER: 'الجنس',
      MALE: 'ذكر',
      FEMALE: 'أنثى'

    },
    SEARCH: {
      ALL_FAQS: "جميع الأسئلة الشائعة",
      WRITE_HERE: 'اكتب هنا..',
      KEYWORD_SUGGESTIONS: 'اقتراحات الكلمات الرئيسية',
      HISTORY: 'آخر عمليات البحث',
      SEARCH: 'بحث',
      SEARCH_RESULT: 'نتائج البحث من',
      READ_MORE: 'اقرأ المزيد',
      FILTER_BY_CATEGORY: 'تصفية حسب الفئة',
      SELECT_CATEGORY: 'تحديد فئة',
      FILTER_BY_TAG: 'تصفية حسب العلامة'
    },
    SUPPLIER: {
      VIEW_FORM: 'مشاهدة النموذج',
      SUBSCRIBE_FOR_THE_TENDER_ALERTS: "اشترك للحصول على تنبيهات المناقصات",
      PLEASE_TICK_THE_BOX_BEFORE_SUBMITTING: "يرجى وضع علامة في المربع قبل الإرسال",
      COMPANY_INFORMATION: "معلومات الشركة",
      VENDOR_NAME: "اسم البائع",
      VENDOR_NUMBER: "رقم البائع",
      COMPANY_REGISTRATION_NUMBER_INTERNATIONAL_CORPORATE_ID: "رقم تسجيل الشركة / المعرّف الدولي للشركات",
      COMPANY_REGISTRATION_EXPIRY: "انتهاء تسجيل الشركة",
      COMPANY_CATEGORY: "فئة الشركة",
      COMPANY_SUB_CATEGORY: "فئة فرعية للشركة",
      DAREEBA_TIN: "الرقم الضريبي لـ داريبا",
      ICV_CERTIFICATE_NUMBER: "رقم شهادة ICV",
      ICV_CERTIFICATE_EXPIRY: "انتهاء شهادة ICV",
      ICV_SCORE: "درجة ICV",
      PRIMARY_CONTACT_NUMBER: "رقم الاتصال الأساسي",
      SECONDARY_CONTACT_NUMBER: 'رقم الاتصال الثانوي',
      CONFIRM_EMAIL: "تأكيد البريد الإلكتروني",
      AUTO_CARE_SUPPLIER: 'مورد العناية بالمركبات',
      AUTO_CARE_FOR_CORPORATES: 'الرعاية التلقائية للشركات',
      ALL: 'جميع الفئات'
    },
    RETAIL: {
      FUEL_RETAIL_PRICES: 'أسعار بيع الوقود بالتجزئة',
      BZS_LITER: 'بيسة / لتر',
      QR_LITER: 'ريال قطري / لتر',
      BECOME_A_SUPPLIER_FOR_SIDRA: 'كن موردًا لمركز السدرة',
      BECOME_A_SUPPLIER_AUTO_CARE: 'كن موردًا للعناية بالمركبات',
      CONTACT_PERSON: 'جهة الاتصال',
      TELEPHONE_NUMBER: 'رقم الهاتف',
      PHONE_NUMBER: 'رقم الهاتف',
      MAILING_ADDRESS: 'عنوان المراسلات',
      EMAIL: 'البريد الإلكتروني',
      FAX_NUMBER: 'رقم الفاكس',
      OFFICE_ADDRESS: 'عنوان المكتب',
      FOR_ADDITIONAL_INFORMATIONS: 'لمزيد من المعلومات',
      VALID_COMPANY_REGISTRATION: 'تسجيل الشركة الصالح',
      YES: 'نعم',
      NO: 'لا',
      SAVE_AND_CONTINUE_LATER: 'حفظ والاستمرار لاحقًا',
      NEXT: 'التالي',
      BACK: 'إلى الخلف',
      YOUR_REMARKS: 'ملاحظاتك',
      PRODUCT_CATEGORY: 'فئة المنتج',
      PAYMENT_TERMS_NUMBER_OF_DAYS: 'شروط الدفع (عدد الأيام)',
      BOOK_NOW: 'احجز الآن',
      QID: 'رقم الهوية',
      VEHICLE_PLATE_TYPE: 'نوع لوحة المركبة',
      VEHICLE_PLATE_NUMBER: 'رقم لوحة المركبة',
      VEHICLE_TYPE: 'نوع المركبة',
      TYPE: 'النوع',
      SAVED_VEHICLES: 'المركبات المحفوظة',
      MANUFACTURER_NAME: 'اسم الشركة المصنعة',
      PETROL_STATION: 'محطة بنزين',
      MODEL: 'نموذج',
      BEST_TIME_TO_CALL: 'أفضل وقت للمكالمه',
      CATEGORY_OF_BUSINESS: 'فئة الأعمال',
      EXPECTED_DATE_TO_START_BUSINESS_OPERATIONS: 'التاريخ المتوقع لبدء العمليات التجارية',
      VAIDATE: 'التحقق من صحة',
      PAYMENT_TERMS: 'شروط الدفع (عدد الأيام)',
      DELIVERY_FREQUENCEY: 'تكرار التسليم',
      ORDERING_LEAD_TIME: 'المهلة الزمنية للطلب',
      SCOPE_OF_DELIVERY: 'نطاق التسليم',
      APPROVE_FOR_LISTING: 'الموافقة على الإدراج',
      TIME: 'الوقت',
      PAYMENT: 'حدد أي خيارات دفع لمتابعة الدفع',
      SUBMIT: 'إرسال'
    },
    FAQ: {
      FAQS: "الأسئلة الشائعة",
      VIEW_ALL_FAQS: "عرض جميع الأسئلة الشائعة",
      ALL_CATEGORY: 'جميع الفئات'
    },
    TINDER: {
      "Current_Status": "الحالة الحالية",
      "bid_closing_date": "تاريخ إغلاق المناقصة",
      "tender_publish_date": "تاريخ نشر المناقصة",
      VENDOR_NAME: 'اسم البائع',
      ADDRESS: 'عنوان',
      CONTACT_NAME: 'اسم جهة الاتصال',
      CONTACT: 'رقم الاتصال#',
      COLLECT_TINDER_DOCUMENT: 'جمع مستندات المناقصه',
      AWARD_TENDERS: 'مناقصات تم منحها',
      CLOSED_TENDERS: 'المناقصات المغلقة',
      OPEN_TENDERS: 'المناقصات المفتوحة',
      SEARCH_BY_AREA_NAME: 'البحث حسب العنوان',
      SEARCH_BY_AREA_NUMBER: 'البحث حسب رقم المناقصة',
      SR_NO: 'الرقم التسلسلي',
      TENDER_NO: 'رقم المناقصة',
      DESCRIPTION: 'الوصف',
      LAST_COLLECTION_DATE: 'تاريخ التجميع الأخير',
      BOND: 'تأمين',
      FEE: 'رسوم',
      CATEGORY: 'الفئة',
      REQUEST: 'طلب',
      VIEW_ALL_TINDERS: 'عرض جميع المناقصات',
      ACTIVE_TINDER: 'المناقصات المتاحة',
      TENDER_TITLE: 'عنوان المناقصة',
      SERIEL_NUMBER: 'الرقم التسلسلي',
      INFORMATION: 'معلومات',
      SUCCESSFUL: 'مقدم عرض ناجح',
      DETAIL: 'عرض التفاصيل',
      CLOSING_DATE: 'تاريخ الإنتهاء',
      View_DETAIL: 'عرض المزيد',
      BID_CLOSING_DATE: 'تاريخ إغلاق المناقصة',
      START_DATE: 'تاريخ إصدار العطاء المخطط له'
    },
    TIMELINE: {
      HOW_TO_USE: 'تعرف كيفية استخدامها'
    },
    TABS: {
      INDIVIDUAL: 'فرد',
      CORPORATE: 'مؤسسة',
      PRODUCTS: 'منتجات',
      SERVICES: 'خدمات',
    },
    PRICE_TABLE: {
      PRICE_TABLE: 'جدول الأسعار',
      SEE_PRICES: 'انظر الأسعار',
      PER_TAG: 'لكل علامة'
    },
    BUSINESS: {
      INITIATE_CONTRACT: 'بدء العقد'
    },
    PRICES: {
      PRICES: 'الأسعار',
      VIEW_ALL_PRICES: 'عرض جميع الأسعار',
      BOOK_AN_APPOINTMENT: 'حجز موعد',
      PRICE_LIST: 'قائمة الأسعار',
      PRICE_IN: 'السعر في'
    },
    STEPS: {
      GET_INSPECTED: "احصل على فحص",
      PAY_NOW: "ادفع الآن",
      CONFIRMATION: "تأكيد",
      SHOP_INFORMATION: 'معلومات المتجر',
      PERSONAL_INFORMATION: 'معلومات شخصية',
      BUSINESS_INFORMATION: 'معلومات العمل',
      ATTACHMENTS: 'المرفقات',
      SUBMISSION: 'تقديم',
      GENERAL_DETAILS: 'تفاصيل عامة',
      VEHICLE_DETAILS: 'تفاصيل المركبة',
      BOOK_APPOINTMENT: 'حجز موعد',
      TERMS_AND_CONDITIONS: 'الشروط والأحكام',
      PAYMENT: 'الدفع',
      SAVED_CARDS: 'البطاقات المحفوظة',
      OPTIONS: 'خيارات الدفع الأخرى',
      EXPIRY: 'تاريخ انتهاء الصلاحية',
      DELETE: 'حذف هذه البطاقة',
      SECURELY: 'ادفع بأمان باستخدام بطاقات الخصم الصادرة في قطر',
      A_SECURE: 'طريقة آمنة وسهلة للدفع باستخدام بطاقات الائتمان',
      PROCEED: 'متابعة',
      DEBIT: 'بطاقة الخصم',
      CREDIT: 'بطاقة إئتمان',
      APPLE_PAY: 'آبل باي'
    },
    E_TAG: {
      SELECT_A_BENEFICIARY: 'إضافة المستفيد',
      ADD_NEW_BENEFICIARY: 'إضافة مستفيد جديد',
      WALLET_LIMIT: 'حد المحفظة',
      REQUEST_A_NEW_E_TAG: 'طلب وسم إلكتروني جديد',
      IF_YOU_HAVE_ALREADY_INSTALLED_A_TAG_AND_WANT_TO_REPLACE_IT_KINDLY: 'إذا كنت قد قمت بتركيب وسم بالفعل وترغب في استبداله، يُرجى',
      CLICK_HERE: 'النقر هنا',
      NAME: 'الاسم',
      QID: 'رقم الهوية',
      INVOICE: 'الفاتورة',
      TRACKING: 'التتبع',
      EMAIL: 'البريد الإلكتروني',
      MOBILE_NUMBER: 'رقم الهاتف',
      NATIONAL_ADDRESS: 'العنوان الوطني',
      ZONE_NUMBER: 'رقم المنطقة',
      STREET_NUMBER: 'رقم الشارع',
      BUILDING: 'المبنى',
      UNIT: 'الوحدة',
      PO_BOX: 'صندوق بريد',
      FAX_NUMBER: 'رقم الفاكس',
      VEHICLE_DETAILS: 'تفاصيل المركبة',
      VEHICLE_STATUS: 'حالة المركبة',
      MODEL: 'الطراز',
      MODEL_YEAR: 'سنة الصنع',
      MANUFACTURE_TO_BE_BRAND: 'الشركة المصنعة (العلامة التجارية)',
      EXPIRY_DATE: 'تاريخ الانتهاء',
      SEQUENCE_NUMBER: 'رقم التسلسل',
      INSURANCE_COMPANY_NAME: 'اسم شركة التأمين',
      START_DATE: 'تاريخ البدء',
      REGISTRATION: 'التسجيل',
      STATUS: 'الحالة',
      VEHICLE_ID_NUMBER: 'رقم هوية المركبة',
      INSURANCE_EXPIRATION_DATE: 'تاريخ انتهاء التأمين',
      PHONE_NUMBER: 'رقم الهاتف',
      SAVE_VEHICLE: 'حفظ المركبة',
      NUMBER_OF_VEHICLES: 'عدد المركبات',
      NUMBER_OF_TAGS: 'عدد الوسوم',
      TOTAL_PRICE: 'السعر الإجمالي',
      ADD_BENEFICIARY: 'إضافة مستفيد',
      CONFIRM: 'تأكيد',
      SELECT_CAR: 'اختر المركبة',
      ADD_A_NEW_CAR: 'إضافة مركبة جديدة',
      CAR: 'مركبة',
      SEARCH_BY_NUMBER_PLATE: 'البحث بواسطة رقم اللوحة',
      RE_INSPECTION: 'إعادة فحص',
      ADD: 'إضافة',
      DETAILS: 'التفاصيل',
      QID_CR: 'الهوية الشخصية / السجل التجاري',
      UPLOAD_FILE: 'تحميل الملف',
      U_FILE: 'تحميل الملف',
      ESTIMARA: 'الاستمارة',
      INSTALLATION_COST: 'تكلفة التركيب',
      TAG_ID: 'معرف الوسم',
      TAG_FEE: 'رسوم الوسم',
      COST_OF_INSTALLATION: 'تكلفة التركيب',
      TOTAL: 'الإجمالي',
      BOOK_DETAILS: 'تفاصيل الحجز',
      PAYMENT_METHOD: 'طريقة الدفع',
      CREDIT_CARD: 'بطاقة ائتمانية',
      KFAST: 'كي-فاست',
      AMEX: 'أميكس',
      OTHER_METHODS: 'طرق دفع أخرى',
      CREDIT_LIMIT: 'الحد الائتماني',
      NET_BANKING: 'الخدمات المصرفية عبر الإنترنت',
      E_Wallet: 'المحفظة الإلكترونية',
      APPLE_WALLET: 'محفظة آبل',
      NEW_CARD: 'بطاقة جديدة',
      NAME_ON_THE_CARD: 'الاسم على البطاقة',
      CARD_NUMBER: 'رقم البطاقة',
      VALID_TILL: 'صالحة حتى',
      CVV: 'الرمز CVV',
      COST_OF_TAG: 'تكلفة العلامة + رسوم التثبيت',
      PLATE_NUMBER: 'رقم اللوحة',
      PLATE_TYPE: 'نوع اللوحة',
      TRANSACTION: 'حد المعاملة (QRA أو لتر)*',
      FUEL_TYPE: 'نوع الوقود *',
      FUEL_LIMIT: 'مدة الحد الأقصى للوقود *',
      MAJOR: 'اللون الرئيسي',
      VEHICLE_INFORMATION: 'معلومات المركبة',
      VEHICLE_INSURANCE: 'تفاصيل تأمين المركبات',
      PHONE: 'رقم التليفون *',
      FAMILY: 'العلاقة العائلية بين حساب العميل ومالك المركبة',
      NUMBER_PLATE: 'لوحة الأرقام',
      MANUFACTOR: 'الصانع',
      DAYS: 'الأيام المتبقية',
      BOOKED_ON: 'تم الحجز',
      BOOKED_DETAILS: 'تفاصيل الحجز',
      Name_AR: 'الاسم بالعربية',
      NUMBER_OF_TAG: 'عدد العلامات',
      BY_NAME: 'البحث حسب اسم الخدمة',
      SERVICE_NAME: 'اسم الخدمة',
      STATION: 'المحطة',
      Max: 'الحد الأقصى للحجم',
      MB: 'ميغابايت',
      SHOULD_BE: 'يُرجى التأكد من أن الملف الذي تقوم بتحميله بصيغة ',
      FORMAT: 'ولا يتجاوز حجمه',
      IN_SIZE: 'في الحجم.',
      "You_can_upload_multiple_files": "يمكنك تحميل ملفات متعددة."
    },
    SHOP: {
      BACK: 'عودة',
      SUBMIT: 'إرسال',
      VEHICLE_TYPE: 'نوع المركبة',
      EXISTING_TENANT: 'مستأجر حالي',
      I_ACCEPT_AND_AGREE_TO_THE_FOLLOWING_TERMS_AND_CONDITIONS: 'أوافق وأقبل على الشروط والأحكام التالية:',
      RENT_A_SHOP: 'استئجار متجر',
      BACK_TO_AVAILABLE_SHOPS_PAGE: 'العودة إلى صفحة المتاجر المتاحة',
      DEADLINE: 'الموعد النهائي',
      LOCATION: 'الموقع',
      FIRST_NAME: 'الاسم الأول',
      STATION_NAME: 'اسم المحطة',
      NUMBER_APPLICANTS: 'عدد المتقدمين حتى الآن',
      SHOP_PRE: 'إيجار المحل شهري (ريال قطري) للمتر المربع',
      SHOP_SIZE: 'مساحة المحل بالمتر المربع',
      NUMBER_OF_SHOPS: 'عدد المحلات التجارية المطلوبة *',
      OPTION: 'خياري',
      LIST_LOCATIONS_IF_ANY: 'قائمة المواقع (إن وجدت)',
      REQUIRED_INFORMATION: 'المعلومات المطلوبة',
      NEXT: 'التالي',
      MIDDLE_NAME: 'الاسم الأوسط',
      LAST_NAME: 'اسم العائلة',
      MOBILE_NUMBER: 'رقم الهاتف',
      OFFICE_TELEPHONE_NUMBER: 'رقم هاتف المكتب',
      EMAIL: 'البريد الإلكتروني',
      COMPANY_NAME: 'اسم الشركة',
      DATE: 'التاريخ',
      WILL_YOU_HAVE_A_PARTNER: 'هل ستكون لديك شريك؟',
      COMPANY_TURNOVER_IN_QATAR: 'إجمالي مبيعات الشركة في قطر',
      NUMBER_OF_EMPLOYEES: 'عدد الموظفين',
      VALIDATE: 'تحقق',
      CR_NUMBER: 'رقم جواز السفر',
      NUMBER_OF_BRANCHES_IN_GSS: 'عدد الفروع في دول مجلس التعاون الخليجي',
      NUMBER_OF_BRANCHES_IN_GCC: 'عدد الفروع في دول مجلس التعاون الخليجي',
      NUMBER_OF_BRANCHES_IN_QATAR: 'عدد الفروع في قطر',
      TERMS_AND_CONDITIONS: 'الشروط والأحكام',
      TERMS_AND_CONDITIONS_FOR_BALLOTING: 'الشروط والأحكام للقرعة',
      TERMS_AND_CONDITIONS_FOR_PROPERTY_RENTALS: 'الشروط والأحكام لتأجير العقارات',
      PAYMENT_SUCCESSFUL: 'تم الدفع بنجاح',
      FUEL_TYPE_CHANGED: 'تم تغيير نوع الوقود',
      LIMITED_HOURS: 'ساعات محدودة',
      FRANCHISE_COMPANY: 'شركة الامتياز',
      COMMERCIAL_REGISTRATION_CR_COPY: 'السجل التجاري (نسخة السجل التجاري)',
      COPY_OF_COMPUTER_CARD_OR_TRADING_LICENSE: 'نسخة من بطاقة الكمبيوتر أو رخصة التجارة',
      BANK_ACCOUNT_DETAILS_IN_THE_COMPANY_LETTERHEAD: 'تفاصيل الحساب البنكي في ترويسة الشركة',
      LETTER_FROM_BANK_CONFIRMING_THE_ACCOUNT: 'خطاب من البنك يؤكد الحساب',
      COPY_OF_OWNERS_ID: 'نسخة من هوية المالك',
      COMPANY_PROFILE: 'ملف تعريف الشركة',
      BRANDING_PROFILE: 'ملف تعريف العلامة التجارية',
      I_AGREE: 'موافق',
      START_DATE: 'تاريخ البدء',
      END_DATE: 'تاريخ الانتهاء',
      SUPPLIER_NAME: 'اسم المورد',
      CONTACT_PERSON: 'الشخص الذي يمكن الاتصال به',
      TRADE: 'رخصة تجارية',
      TAX_CARD: 'بطاقة ضريبية',
      AUTO_CARE: 'خدمات العناية بالمركبات',
      PRODUCT: 'وصف المنتج',
      INSURANCE_COMPANY: 'قائمة شركات التأمين',
      INSURANCE: 'شركة التأمين',
      CR_START_DATE: 'تاريخ بدء السجل التجاري',
      CR_END_DATE: 'تاريخ انتهاء السجل التجاري',
    },
    UPLOADER: {
      ATTACH: 'إرفاق'
    },
    DAYS: {
      MON: "الاثنين",
      TUE: "الثلاثاء",
      WED: "الأربعاء",
      THU: "الخميس",
      FRI: "الجمعة",
      SAT: "السبت",
      SUN: "الأحد"
    },
    INSPECTION_FILTER: {
      FULL_DAY_FULL_WEEK: '24 ساعة / 7 أيام في الأسبوع',
      CHOOSE_STATION: 'اختر المحطة',
      CHOOSE_ANY: 'اختر أيًا',
      CHOOSE_STATUS: 'اختر الحالة',
      SELECT_YOUR_PETROL_STATION_TYPE: 'اختر نوع المحطة الخاصة بك',
      SELECT_YOUR_PETROL_STATION_TYPE_NEW: 'اختر نوع خدمة محطة البنزين الخاصة بك',      
      SELECT_YOUR_PETROL_STATION_STATUS: 'اختر حالة محطة الوقود الخاصة بك',
      SELECT_BY_SERVICE_AVAILABLE: 'اختر حسب الخدمة المتاحة',
      SEARCH_LOCATIONS: 'البحث عن المواقع',
      EG: 'على سبيل المثال',
      WORKING_HOURS: 'ساعات العمل',
      SORT_BY: 'فرز حسب',
      SORT_BY_NEAREST_STATIONS: 'الترتيب حسب أقرب المحطات',
      OPEN_24_HOURS: 'مفتوح 24 ساعة',
      DIRECTION: 'الاتجاه',
    },
    TIME: {
      CHOOSE_TIME: 'اختر الوقت'
    },
    KENAR_PAGE: {
      DEADLINE: 'الموعد النهائي',
      RENT_SHOP: 'إستأجر المتجر',
      SEARCH_BY_TITLE: 'البحث حسب العنوان',
      SUBMIT_INTEREST_IN_LEASING_A_SHOP: 'تقديم الاهتمام بتأجير متجر'
    },
    SIDRA: {
      VISIT_SIDRA_WEBSITE: 'زيارة موقع السدرة',
      SHOP_NOW: 'تسوق الآن'
    },
    PRODUCT_AND_SERVICE: {
      FUEL: 'الوقود والتجزئة',
      WAQOD: 'العناية بالمركبات',
      READ_MORE: 'اقرأ أكثر',
      KINAR: 'كنار',
      SIDRA: 'سدرة',
      SHAFAF: 'شفاف',
      BULK: 'الوقود السائب',
      DISTRIBUTION: 'توزيع الوقود',
      GAS: 'توزيع الغاز',
      AVIATION: 'إمدادات الطيران',
      VIEW_OTHER_PRODUCTS: 'عرض منتجات اخرى',
      ENTER_YOUR_QUERIES: 'أدخل معلومات الاستعلام',
      FOR_MORE_INFORMATION: 'للمزيد من المعلومات',
    },
    SHAFAF: {
      RATES: 'مقاسات الأسطوانة',
      LPG_ACCESSORIES: 'ملحقات LPG',
      VISIT_SHAFAF: 'قم بزيارة موقع شفاف',
      WHERE_TOBUY_SHAFAF: 'مكان الشراء شفاف',
      VIEW: 'عرض القائمة',
      STORES: '(متوفرة في جميع متاجر سدرة)',
    },
    FUELMODAL: {
      TITLE: 'أسعار الوقود لهذا العام',
      MONTH: 'شهر',
      GAS_SUPER: 'بنزين سوبر (95)',
      GAS_PRE: 'البنزين الممتاز (91)',
      DIESEL: 'ديزل',
    },
    FILTER_DDL: {
      CONTACT_NUMBER: 'ترتيب حسب رقم الاتصال تصاعديا',
      CONTACT_NUMBER_DESC: 'ترتيب حسب رقم الاتصال تنازليا',
      TITLE: 'ترتيب حسب عنوان',
      STATION: 'ترتيب حسب المحطة تصاعدي',
      STATION_DESC: 'ترتيب حسب المحطة تنازليا',
      ADDRESS: 'ترتيب حسب العنوان تصاعديا',
      ADDRESS_DESC: 'ترتيب حسب العنوان تنازليا',
      CONTACT_NAME: 'ترتيب حسب اسم جهة الاتصال تصاعديًا',
      CONTACT_NAME_DESC: 'ترتيب حسب اسم جهة الاتصال تنازليا',
      TITLE_DESC: 'ترتيب حسب العنوان تنازليا',
      TITLE_ASC: 'ترتيب حسب العنوان تصاعدي',
    },
    TENDER_MODAL: {
      CR_CERTIFICATE: 'شهادة السجل التجاري',
      ADDRESS: 'العنوان الوطني',
    },
    PLACEHOLDER: {
      DDMMYYYY: 'يوم/شهر/سنة',
      ENTER_COMPANY_NAME: 'أدخل اسم الشركة',
      DECLARATION: 'بيان',
      PRODUCT_DESCRIPTION: 'وصف المنتج',
      QID: '29712345678',
      EMAIL: 'John@gmail.com',
      SUPPLIER_NAME: 'محطة بنزين عين سنان',
      CONTACT_PERSON: 'جون أحمد',
      CR_NUMBER: '22445',
      S_DATE: '20 / 2 / 2020',
      E_DATE: '20 / 2 / 2020',
      F_NAME: 'جون',
      M_NAME: 'صموئيل',
      L_NAME: 'جوني',
      MOBILE: '٩٤٧ ٤٥٦٧٨٩٦٧',
      NUMBER: '20',
      NUMBER_GCC: '68',
      EMPLOYE_NUMBERR: '368',
      LIST_LOCATIONS: 'أدخل مواقع القائمة (إن وجدت)',
      TURNOVER: "أدخل حجم مبيعات شركتك في قطر (ريال قطري)*",
      NATIONALTIY: 'حدد جنسيتك',
      EDUCATION: "درجة البكالوريوس",
      FIELD: 'علم الكمبيوتر',
      CURRENT: 'موظف',
      YEARS: '7',
      INDUSTRY: 'التصنيع',
      EMPOYLER: 'شركة ABC',
      FULL_NAME: 'عبدالقادر أحمد',
      AHMED: 'أحمد',
      FEEDBACK_TITLE: 'عنوان ملاحظاتك',
      FEEDBACK_TITLE_AR: 'عنوان ملاحظاتك باللغة العربية',
      COMPANY: 'شركة وقود',
      COMMENTS: 'أدخل تعليقاتك هنا...',
      ZONE: 'أدخل رقم المنطقة (مثال: 123)',
      BUILDING: 'أدخل اسم المبنى أو رقمه',
      UNIT: 'أدخل اسم الوحدة أو رقمها',
      NAME_EN: 'ex: John Samuel',
      NAME_AR: 'عبدالقادر أحمد',
      ENTER_LOCATION: 'أدخل الموقع',
      SHOW_ALL: 'عرض الكل',
      ACTIVE_ONLY: 'نشط فقط',
      NEARSET: 'الأقرب',
      NEWLY_ADDED: 'مضاف حديثا',
      BY_STATION: 'البحث حسب اسم المحطة',
      DEADLINE: 'ترتيب الموعد النهائي ',
      LASTEST_ADDED: 'ترتيب المضاف حديثا',
      SIZE_ASC: 'ترتيب الحجم تصاعدي',
      SIZE_DESC: 'ترتيب الحجم تنازليا',
      DATE_FROM: 'من تاريخ',
      DATE_TO: 'الى تاريخ',
      CORORATE_ID: 'أدخل رقم تسجيل الشركة/معرف الشركة الدولي',
      CERTEFICATE_NUMBER: 'ABC-9876543',
      ICV_SCORE: '48 نقطة',
      DATE: 'يوم-شهر-سنة',
      COUNTRY: 'الدولة',
      GENDER: 'السيد / السيدة',
      TITLE: 'عنوان',
      VALID_NUMBER: 'أدخل رقمًا صالحًا',
      VALID_EMAIL: 'أدخل بريد إلكتروني صالح',
      ENTER_YOUR_NAME: 'أدخل اسمك',
      CURRENT_EMPLOYER: 'مهندس برمجيات',
      DEVELOPER: ' مطور برمجيات',
      ENTER_YOUR_EMAIL: 'أدخل بريدك الإلكتروني',
      ENTER_YOUR_MOBILE_NUMBER: 'أدخل رقم هاتفك المحمول',
      ENTER_YOUR_DESCRIPTION: 'أدخل وصفك',
      ENTER_PLATE_NUMBER: 'أدخل رقم اللوحة',
    },
    PAYMENT: {
      "credit card": "بطاقة إئتمان",
      "Debit Card": "بطاقة الخصم",
      ID: 'رقم المعاملة',
      DATE: 'تاريخ المعاملة',
      METHODS: 'طريقة الدفع',
      TOTAL: 'إجمالي مبلغ تعبئة الرصيد',
      CONGRATS: 'تهانينا',
      INTO_WALLET: 'تضاف إلى محفظتك',
      YOU_HAVE: 'لديك',
      AVAILABLE: 'متوفر في المحفظة',
      PAYMENT_FAILED: "لم نتمكن من معالجة طلب الدفع",
      CARD_SAVED_SUCCESSFULLY: 'تم حفظ البطاقة بنجاح',
      CANCEL: 'تم إلغاء العملية',
      TOPUP_COMPLETED: 'تم إكمال عملية التعبئة',
      BALANCE: 'رصيدك الحالي هو',
      PRINT: 'طباعة الإيصال',
      DETAILS: 'تفاصيل المعاملة',
    },
    INVESTOR: {
      RELATIONS: 'علاقات المستثمرين',
      EXECUTIVE_MANAGEMENT: 'الإدارة التنفيذية',
    },
    CONTACT: {
      Timing: 'توقيت المكتب',
      WE_ARE_OPEN: 'نحن متاحون على',
      TODAY: 'من الساعة 7 صباحاً إلى 2 ظهراً (الأحد - الخميس)',
      EMAIL: 'أرسل لنا بريداً إلكترونياً',
      FAX: 'أرسل لنا فاكس',
      CALL: 'اتصل بنا'
    }
  }
};
